/* eslint-disable no-unused-vars */
// import { general_routes } from "./general";
const roles = {
  path: "roles",
  component: () => import("@/views/pages/admin/Admin"),
  children: [
    {
      path: "",
      name: "admin-roles",
      meta: { section: "admin", permissions: ["browse-roles"] },
      component: () => import("@/views/pages/admin/roles/Roles.vue")
    },
    {
      path: "roles/view/:id",
      name: "view-admin-role",
      meta: { section: "admin", permissions: ["read-roles"] },
      component: () => import("@/views/pages/admin/roles/RoleForm.vue")
    },
    {
      path: "roles/edit/:id",
      name: "edit-admin-role",
      meta: { section: "admin", permissions: ["edit-roles"] },
      component: () => import("@/views/pages/admin/roles/RoleForm.vue")
    },
    {
      path: "roles/create",
      name: "create-admin-role",
      meta: { section: "admin", permissions: ["add-roles"] },
      component: () => import("@/views/pages/admin/roles/RoleForm.vue")
    }
  ]
};

const permissions = {
  path: "permissions",
  component: () => import("@/views/pages/admin/Admin"),
  children: [
    {
      path: "",
      name: "admin-permissions",
      meta: { section: "admin", permissions: ["browse-permissions"] },
      component: () => import("@/views/pages/admin/permissions/Permissions.vue")
    },
    {
      path: "permissions/view/:id",
      name: "view-admin-permission",
      meta: { section: "admin", permissions: ["read-permissions"] },
      component: () =>
        import("@/views/pages/admin/permissions/PermissionForm.vue")
    },
    {
      path: "permissions/edit/:id",
      name: "edit-admin-permission",
      meta: { section: "admin", permissions: ["edit-permissions"] },
      component: () =>
        import("@/views/pages/admin/permissions/PermissionForm.vue")
    },
    {
      path: "permissions/create",
      name: "create-admin-permission",
      meta: { section: "admin", permissions: ["add-permissions"] },
      component: () =>
        import("@/views/pages/admin/permissions/PermissionForm.vue")
    }
  ]
};

const users = {
  path: "users",
  component: () => import("@/views/pages/admin/Admin"),
  children: [
    {
      path: "",
      name: "admin-users",
      meta: { section: "admin", users: ["browse-users"] },
      component: () => import("@/views/pages/admin/users/Users.vue")
    },
    {
      path: "users/view/:id",
      name: "view-admin-user",
      meta: { section: "admin", users: ["read-users"] },
      component: () => import("@/views/pages/admin/users/UserForm.vue")
    },
    {
      path: "users/edit/:id",
      name: "edit-admin-user",
      meta: { section: "admin", users: ["edit-users"] },
      component: () => import("@/views/pages/admin/users/UserForm.vue")
    },
    {
      path: "users/create",
      name: "create-admin-user",
      meta: { section: "admin", users: ["add-users"] },
      component: () => import("@/views/pages/admin/users/UserForm.vue")
    }
  ]
};

var routes = [
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    component: () => import("@/views/theme/Base"),
    meta: { section: "admin" },
    children: [
      {
        path: "dashboard",
        name: "admin-dashboard",
        meta: { section: "admin" },
        component: () => import("@/views/pages/admin/Dashboard.vue")
      },
      roles,
      permissions,
      users
    ]
  },
  {
    path: "/admin",
    component: () => import("@/views/pages/auth/Auth1"),
    meta: { section: "admin" },
    children: [
      {
        name: "admin-login",
        path: "login",
        meta: { section: "admin" },
        component: () => import("@/views/pages/auth/Login1")
      }
    ]
  },
  {
    path: "/admin/not-found",
    name: "admin-404",
    meta: {
      section: "admin",
      code: 404
    },
    component: () => import("@/views/pages/error/MainError.vue")
  },
  {
    path: "/admin/not-authorised",
    name: "admin-403",
    meta: {
      section: "admin",
      code: 403
    },
    component: () => import("@/views/pages/error/MainError.vue")
  }
  //   ,
  //   ...general_routes("admin-", { section: "admin" })
];

export const admin_routes = routes;
